import api from "./api";

// Capa de servicios API del dominio "control de acceso" (FSD).
// Wrappers de transporte finos: el endpoint vive aquí, la construcción de
// payloads en el componente. Backend: módulo hexagonal `crm-access` (doc 0380).

// --- Permisos del propio usuario ---
export const getMyPermissions = () => api.get("/me/permissions");
export const getMyTeams = () => api.get("/me/teams");

// --- Subagrupaciones (equipos) ---
export const listUserGroups = () => api.get("/user-groups");
export const getUserGroup = (groupId) => api.get(`/user-groups/${groupId}`);
export const createUserGroup = (payload) => api.post("/user-groups", payload);
export const updateUserGroup = (groupId, payload) =>
  api.put(`/user-groups/${groupId}`, payload);
export const deleteUserGroup = (groupId) => api.delete(`/user-groups/${groupId}`);

// --- Roles y permisos ---
export const listRoles = () => api.get("/roles");
export const getRole = (roleId) => api.get(`/roles/${roleId}`);
export const listPermissions = () => api.get("/permissions");
export const createRole = (payload) => api.post("/roles", payload);
// Copia editable de un rol. El origen no se toca (doc 0380 H3).
export const duplicateRole = (roleId, payload) =>
  api.post(`/roles/${roleId}/duplicate`, payload);
export const updateRole = (roleId, payload) => api.put(`/roles/${roleId}`, payload);
export const setRolePermissions = (roleId, permissionIds) =>
  api.put(`/roles/${roleId}/permissions`, { permissionIds });
export const deleteRole = (roleId) => api.delete(`/roles/${roleId}`);

// ── Equipos de un usuario, desde su ficha (doc 0380 D11 · paso 2.B) ─────────
//
// Es la misma tabla que edita la pantalla de subagrupaciones, vista del otro
// lado. Exige permiso de EQUIPOS y no de usuarios: asignar un rol contextual
// otorga permisos, así que la guarda mide el efecto y no la pantalla de origen.
export const getUserTeams = (userId) => api.get(`/users/${userId}/teams`);
export const setUserTeams = (userId, teams) =>
  api.put(`/users/${userId}/teams`, { teams });

// Personas de la empresa con el equipo en el que ya están (migración 336).
// Alimenta el selector de miembros: quien ya tiene equipo no se puede reclutar.
export const listAssignableUsers = () => api.get("/assignable-users");
